import { ServerFetch } from '../main-model'

export default class PromotionGroupModel extends ServerFetch {
    getPromotionGroupBy = (data) => this.authFetch({
        url: 'promotion-group/getPromotionGroupBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}